<div class="overview_trainee" >
   <h5>Liste des stagiaires de la session</h5>
  <div class="trainee_content">
    <ng-container *ngIf="trainees?.length" >
      <div class="trainee" *ngFor="let t of trainees">
        <fa-icon [icon]="getFaIcon('faUser')" appChangeColorTheme attribute="color"></fa-icon>
        <span>{{t.traineeLastName}} {{t.traineeFirstName}}</span>
      </div>
    </ng-container>

  <p class="no_trainee" *ngIf="!trainees?.length">Aucun stagiaire</p>

  </div>

</div>